/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1QuotesConversionCreatePathParameters,
  BillingV1QuotesConversionRemovalsCreatePathParameters,
  BillingV1QuotesConversionRetrievePathParameters,
  BillingV1QuotesDestroyPathParameters,
  BillingV1QuotesListParams,
  BillingV1QuotesPartialUpdatePathParameters,
  BillingV1QuotesPdfRetrievePathParameters,
  BillingV1QuotesRetrievePathParameters,
  CursorPaginatedQuoteResponseV1,
  PatchedQuoteUpdateRequestV1Request,
  QuoteConversionPiecesResponseV1,
  QuoteConversionRemovalRequestV1Request,
  QuoteConversionRequestV1Request,
  QuoteConversionResponseV1,
  QuoteCreateRequestV1Request,
  QuoteResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingQuoteService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. The works and lines of each quote are served by its sub-resources.
 * @summary List quotes (cursor-paginated), newest first.
 */
 billingV1QuotesList<TData = CursorPaginatedQuoteResponseV1>(params?: BillingV1QuotesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesList<TData = CursorPaginatedQuoteResponseV1>(params?: BillingV1QuotesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesList<TData = CursorPaginatedQuoteResponseV1>(params?: BillingV1QuotesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesList<TData = CursorPaginatedQuoteResponseV1>(
    params?: BillingV1QuotesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Creates the client, the billing address and the subscription of a quote; its catchment works and lines are added afterwards through their sub-resources, so a new quote totals 0. `valid_until` is the Chilean day the quote is created plus `valid_for_days`, and `subscription.fee_uf` defaults to Configuration[SYSTEM_FEE_UF]. The subscription is in UF only: its CLP value is fixed when each subscription charge is emitted. With `subscription: null` the quote offers none (M-bill-21). `user_id` makes it a quote for a client who already exists: `client_rut` is their username, and a client without a billing profile gets one from this body.
 * @summary Create a quote (header only).
 */
 billingV1QuotesCreate<TData = QuoteResponseV1>(quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesCreate<TData = QuoteResponseV1>(quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesCreate<TData = QuoteResponseV1>(quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesCreate<TData = QuoteResponseV1>(
    quoteCreateRequestV1Request: QuoteCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quotes/`,
      quoteCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only.
 * @summary Get one quote.
 */
 billingV1QuotesRetrieve<TData = QuoteResponseV1>(pathParams: BillingV1QuotesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesRetrieve<TData = QuoteResponseV1>(pathParams: BillingV1QuotesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesRetrieve<TData = QuoteResponseV1>(pathParams: BillingV1QuotesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesRetrieve<TData = QuoteResponseV1>(
    { identity }: BillingV1QuotesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Only the keys sent change, inside `address` too. A new `subscription.cadence` reads `months_billed` again from the Config; a new `total_discount_pct` rolls the totals up again. A new `valid_for_days` counts from the Chilean day the quote was created and can only grow: the quote binds its prices until `valid_until`. `subscription: null` drops the subscription; an object gives the quote one or changes its terms, and on a quote without one the fee and the grace it omits take the create's (M-bill-21). The RUT of a quote for a client is their username. A converted quote takes only its contact: `client_first_name`, `client_last_name`, `client_email` and `client_phone` (Ley 21.719 art. 6, S-bill-3); its totals stay.
 * @summary Partial-update a quote (preserve-on-omit).
 */
 billingV1QuotesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuotesPartialUpdatePathParameters,
    patchedQuoteUpdateRequestV1Request?: PatchedQuoteUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuotesPartialUpdatePathParameters,
    patchedQuoteUpdateRequestV1Request?: PatchedQuoteUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesPartialUpdate<TData = QuoteResponseV1>(pathParams: BillingV1QuotesPartialUpdatePathParameters,
    patchedQuoteUpdateRequestV1Request?: PatchedQuoteUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesPartialUpdate<TData = QuoteResponseV1>(
    { identity }: BillingV1QuotesPartialUpdatePathParameters,
    patchedQuoteUpdateRequestV1Request?: PatchedQuoteUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/`,
      patchedQuoteUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/`,
      patchedQuoteUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/quotes/${identity}/`,
      patchedQuoteUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. 204 with no body. A converted quote is not deleted (409).
 * @summary Delete a quote with its catchment works and lines.
 */
 billingV1QuotesDestroy<TData = void>(pathParams: BillingV1QuotesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesDestroy<TData = void>(pathParams: BillingV1QuotesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesDestroy<TData = void>(pathParams: BillingV1QuotesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesDestroy<TData = void>(
    { identity }: BillingV1QuotesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/quotes/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-16). The checklist for undoing a conversion done by mistake: the client (only when the conversion created them), the real catchment works of its drafts, its installation and service charges, and the subscription it created. Each piece says in `blocked_by` what stops it from being removed. The picked ones are removed with POST .../conversion/removals/.
 * @summary What the conversion of a quote created, to undo it.
 */
 billingV1QuotesConversionRetrieve<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesConversionRetrieve<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesConversionRetrieve<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesConversionRetrieve<TData = QuoteConversionPiecesResponseV1>(
    { identity }: BillingV1QuotesConversionRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-16). One transaction, all or nothing: the client (the user whose username is the RUT of the quote, created without a usable password when there is none), their billing profile from the quote (a stored city stays), one catchment work per draft without a datalogger, its installation and service charges in blocks of up to 16 lines at the quote's prices, and the subscription from `active_from` when the quote offers one, unless the client already has one overlapping it. The quote is left converted: it takes no more changes, and its charges keep its prices.
 * @summary Convert an accepted quote into the client, their catchment works and charges.
 */
 billingV1QuotesConversionCreate<TData = QuoteConversionResponseV1>(pathParams: BillingV1QuotesConversionCreatePathParameters,
    quoteConversionRequestV1Request?: QuoteConversionRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesConversionCreate<TData = QuoteConversionResponseV1>(pathParams: BillingV1QuotesConversionCreatePathParameters,
    quoteConversionRequestV1Request?: QuoteConversionRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesConversionCreate<TData = QuoteConversionResponseV1>(pathParams: BillingV1QuotesConversionCreatePathParameters,
    quoteConversionRequestV1Request?: QuoteConversionRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesConversionCreate<TData = QuoteConversionResponseV1>(
    { identity }: BillingV1QuotesConversionCreatePathParameters,
    quoteConversionRequestV1Request?: QuoteConversionRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,
      quoteConversionRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,
      quoteConversionRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/`,
      quoteConversionRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only (M-bill-16). For a conversion done by mistake: removes the pieces the body picks, as GET .../conversion/ lists them, all or none, and answers what is left. Once nothing is left, the quote is not converted any more: it takes changes and converts again. A client who existed before the conversion, their billing profile and the PDFs already sent stay.
 * @summary Undo the picked pieces of the conversion of a quote.
 */
 billingV1QuotesConversionRemovalsCreate<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRemovalsCreatePathParameters,
    quoteConversionRemovalRequestV1Request?: QuoteConversionRemovalRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1QuotesConversionRemovalsCreate<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRemovalsCreatePathParameters,
    quoteConversionRemovalRequestV1Request?: QuoteConversionRemovalRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1QuotesConversionRemovalsCreate<TData = QuoteConversionPiecesResponseV1>(pathParams: BillingV1QuotesConversionRemovalsCreatePathParameters,
    quoteConversionRemovalRequestV1Request?: QuoteConversionRemovalRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1QuotesConversionRemovalsCreate<TData = QuoteConversionPiecesResponseV1>(
    { identity }: BillingV1QuotesConversionRemovalsCreatePathParameters,
    quoteConversionRemovalRequestV1Request?: QuoteConversionRemovalRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/removals/`,
      quoteConversionRemovalRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/removals/`,
      quoteConversionRemovalRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/quotes/${identity}/conversion/removals/`,
      quoteConversionRemovalRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. A binary PDF for the prospect: the client, one block per draft catchment work with its lines (each with its item, its note, the unit sale price, the quantity, the discount and the subtotal; neither the cost nor the margin of a line is printed), the one-time totals read from the quote, and the subscription in UF only. Informational, not a SII tax document. Rendered synchronously, nothing is stored.
 * @summary Download the PDF of a quote.
 */
 billingV1QuotesPdfRetrieve(pathParams: BillingV1QuotesPdfRetrievePathParameters, options?: HttpClientBodyOptions): Observable<Blob>;
 billingV1QuotesPdfRetrieve(pathParams: BillingV1QuotesPdfRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 billingV1QuotesPdfRetrieve(pathParams: BillingV1QuotesPdfRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  billingV1QuotesPdfRetrieve(
    { identity }: BillingV1QuotesPdfRetrievePathParameters, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/v1/billing/quotes/${identity}/quote.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/v1/billing/quotes/${identity}/quote.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/v1/billing/quotes/${identity}/quote.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
};

export type BillingV1QuotesListClientResult = NonNullable<CursorPaginatedQuoteResponseV1>
export type BillingV1QuotesCreateClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuotesRetrieveClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuotesPartialUpdateClientResult = NonNullable<QuoteResponseV1>
export type BillingV1QuotesDestroyClientResult = NonNullable<void>
export type BillingV1QuotesConversionRetrieveClientResult = NonNullable<QuoteConversionPiecesResponseV1>
export type BillingV1QuotesConversionCreateClientResult = NonNullable<QuoteConversionResponseV1>
export type BillingV1QuotesConversionRemovalsCreateClientResult = NonNullable<QuoteConversionPiecesResponseV1>
export type BillingV1QuotesPdfRetrieveClientResult = NonNullable<Blob>
